import {withStyles} from "@material-ui/core/styles";
import Switch from '@material-ui/core/Switch';

const FilterSwitch = withStyles({
  root: {
    height: 24,
    fontWeight: '400',
    fontFamily: 'Thasadith, sans-serif',
    color: 'DimGray'
  },
  switchBase: {
    height: 24,
  }
})(Switch);

export default FilterSwitch;
